<template>
    <div id="exportVerify" class="content">
                <h4>{{ title }}</h4>
                <hr>
                <div class="row ">
                    <div class="col-sm-11">
                        <form class="form" @submit.prevent="goToExport">
                            <div class="form-group row">
                                <div class="col-sm-2">
                                    <label class="control-label" for="created_at">{{ label.start_date }}</label>
                                </div>
                                <div class="col-sm-3">
                                    <input type="date" class="form-control" required id="start_date" name="new_start_date" v-model="reqCrit.start_date" >
                                </div>
                                <div class="col-sm-2">
                                    <label class="control-label" for="ended_at">{{ label.end_date }}</label>
                                </div>
                                <div class="col-sm-3">
                                    <input type="date" class="form-control" required id="end_date" name="end_date" v-model="reqCrit.end_date" >
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-sm-2" >
                                    <label class="control-label">{{ label.template_id }}</label>
                                </div>
                                <div class="col-sm-4">
                                    <select class="form-control" v-model="reqCrit.template_id" required>
                                        <option v-for="(item, index) in templates" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                    </select>
                                </div>
                                <div class="col-sm-4">
                                    <button type="button" class="btn btn-primary" slot="activator" @click="retriveTemplate(reqCrit.template_id)">View</button>
                                    <v-dialog v-model="dialogTemplate" max-width="800px">
                                        <v-card>
                                            <table class="table">
                                                <thead class="thead-primary">
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Required</th>
                                                        <th>Sequence</th>
                                                        <th>Format</th>
                                                        <th>Char</th>
                                                        <th>In / Out Indicator</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in template" :key="index">
                                                        <td>{{ item.row_name }}</td>
                                                        <td>{{ item.required | toggleYN }}</td>
                                                        <td>{{ item.sequence }}</td>
                                                        <td>{{ item.type_format }}</td>
                                                        <td>{{ item.no_char}}</td>
                                                        <td>{{ item.in_out_inc}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </v-card>
                                        <v-card-actions class="justify-center">
                                            <v-btn @click="dialogTemplate = false">CLOSE</v-btn>
                                        </v-card-actions>
                                    </v-dialog>
                                </div>
                            </div> 

                            <div class="form-group row">
                                <div class="col-sm-2" >
                                    <label class="control-label">{{ label.filename }}</label>
                                </div>
                                <div class="col-sm-8">
                                    <input type="text" class="form-control" required id="filename" name="filename" v-model="reqCrit.filename" >
                                </div>
                            </div> 

                            <div class="form-group row">
                                <div class="col-sm-2" >
                                    <span style="color: blue">Filter By </span>  
                                </div>
                                
                                
                            </div>

                            <div class="form-group row">
                                <div class="col-sm-2" >
                                    <label class="control-label">{{ label.project_id }}</label>
                                </div>
                                <div class="col-sm-3">
                                    <select class="form-control" v-model="reqCrit.project_id" v-on:change="setProjectsSelection()">
                                        <option v-for="(item, index) in projects" :key="index" v-bind:value="{id: item.id, name: item.display_name}">{{ item.display_name }}</option>
                                    </select>
                                    <div>
                                        <span v-if="projectSelection != '' ">Selected:
                                            <ul style="list-style: none;" v-for="(item, index) in projectSelection" :key="index">
                                                <li><v-icon @click="delProjectsSelection(index)">delete</v-icon>{{ item.name }} </li>
                                            </ul>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-sm-2" >
                                    <label class="control-label">{{ label.reason_id }}</label>
                                </div>
                                <div class="col-sm-3">
                                    <select class="form-control" v-model="reqCrit.reason_id" v-on:change="setReasonsSelection()">
                                        <option v-for="(item, index) in reasons" :key="index" v-bind:value="{id : item.id, name: item.display_name}">{{ item.display_name }}</option>
                                    </select>
                                    <div>
                                        <span v-if="reasonSelection != '' ">Selected:
                                            <ul style="list-style: none;" v-for="(item, index) in reasonSelection" :key="index">
                                                <li><v-icon  @click="delReasonsSelection(index)">delete</v-icon>{{ item.name }} </li>
                                            </ul>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-sm-2" >
                                    <label class="control-label">{{ label.company_id }}</label>
                                </div>
                                <div class="col-sm-3">
                                    <select class="form-control" v-model="reqCrit.company_id" v-on:change="setCompaniesSelection()">
                                        <option v-for="(item, index) in companies" :key="index" v-bind:value="{id : item.id, name: item.display_name}">{{ item.display_name }}</option>
                                    </select>
                                    <div>
                                        <span v-if="companySelection != '' ">Selected:
                                            <ul style="list-style: none;" v-for="(item, index) in companySelection" :key="index">
                                                <li><v-icon @click="delCompaniesSelection(index)">delete</v-icon>{{ item.name }} </li>
                                            </ul>
                                        </span>
                                    </div>
                                </div>
                            </div>

                             <div class="form-group row">
                                <div class="col-sm-2" >
                                    <label class="control-label">{{ label.geolocation_id }}</label>
                                </div>
                                <div class="col-sm-3">
                                    <select class="form-control" v-model="reqCrit.geolocation_id" v-on:change="setGeolocationSelection()">
                                        <option v-for="(item, index) in geolocation" :key="index" v-bind:value="{id: item.id, name: item.location_name}">{{ item.location_name }}</option>
                                    </select>
                                    <div>
                                        <span v-if="geolocationSelection != '' ">Selected:
                                            <ul style="list-style: none;" v-for="(item, index) in geolocationSelection" :key="index">
                                                <li><v-icon @click="delgeolocationsSelection(index)">delete</v-icon>{{ item.name }} </li>
                                            </ul>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row text-center">
                                <div class="col-sm-11">                        
                                    <button type="submit" class="btn btn-primary" >VERIFY</button>
                                    <router-link :to="`/${$i18n.locale}/home`"><button class="btn btn-primary">CANCEL</button></router-link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import store from '../../store/store.js'

export default {
    data() {
        return {
            title: 'Clock Data Export',
            label: {
                start_date: 'Export From',
                end_date: 'Export Until',
                template_id: 'Export Template',
                project_id: 'Project',
                reason_id: 'Reason',
                company_id: 'Company',
                geolocation_id: 'Geofencing',
                filename: 'File Name'
            },
            reqCrit: {
                start_date: moment().format('YYYY-MM-DD'),
                end_date: moment().format('YYYY-MM-DD'),
                template_id: null,
                project_id: '',
                reason_id: '',
                company_id: '',
                geolocation_id: '',
                filename: null
            },
            reasonSelection: [],
            projectSelection: [],
            companySelection: [],
            geolocationSelection: [],
            templates: [],
            projects: [],
            reasons: [],
            companies: [],
            geolocation: [],
            template: [],
            dialogTemplate: false
        }
    },

    methods: {
        setReasonsSelection() {
            var reasonsSel = []

            if (this.reqCrit.reason_id !== null) {
                reasonsSel.push(this.reqCrit.reason_id)

                for (let i =0; i < reasonsSel.length; ++i) {
                    this.reasonSelection.push(reasonsSel[i])
                }
            }

        },

        delReasonsSelection(i) {
            this.reqCrit.reason_id = ''
            this.reasonSelection.splice(i, 1)
        },

        setProjectsSelection() {
            var projectSel = []

            if (this.reqCrit.project_id !== null) {
                projectSel.push(this.reqCrit.project_id)

                for (let i =0; i < projectSel.length; ++i) {
                    this.projectSelection.push(projectSel[i])
                }
            }

        },

        delProjectsSelection(i) {
            //document.getElementById("projectOption").selectedIndex = "-1"
            this.reqCrit.project_id = ''
            this.projectSelection.splice(i, 1)
            
        },

        setCompaniesSelection() {
            var companySel = []

            if (this.reqCrit.company_id !== null) {
                companySel.push(this.reqCrit.company_id)

                for (let i =0; i < companySel.length; ++i) {
                    this.companySelection.push(companySel[i])
                }
            }

        },

        delCompaniesSelection(i) {
            this.reqCrit.company_id = ''
            this.companySelection.splice(i, 1)
        },

        setGeolocationSelection() {
            var geolocationSel = []

            if (this.reqCrit.geolocation_id !== null) {
                geolocationSel.push(this.reqCrit.geolocation_id)

                for (let i =0; i < geolocationSel.length; ++i) {
                    this.geolocationSelection.push(geolocationSel[i])
                }
            }
        },

        delgeolocationsSelection(i) {
            this.reqCrit.geolocation_id = ''
            this.geolocationSelection.splice(i, 1)
            
        },

        retriveTemplates() {
            let vm = this

            axios.get(this.$store.getters.rootAPI + '/export/template/list')
            .then(function (response) {
                vm.templates = response.data.rec;
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        retriveProjects() {
            let vm = this

            axios.get(this.$store.getters.rootAPI + '/clock/projects/list')
            .then(function (response) {
                vm.projects = response.data.rec;
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        retriveReasons() {
            let vm = this

            axios.get(this.$store.getters.rootAPI + '/clock/reason/list')
            .then(function (response) {
                vm.reasons = response.data.rec;
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        retriveCompanies() {
            let vm = this

            axios.get(this.$store.getters.rootAPI + '/company/list')
            .then(function (response) {
                vm.companies = response.data.rec;
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        retriveGeolocation() {
            let vm = this

            axios.get(this.$store.getters.rootAPI + '/geolocation/list')
            .then(function (response) {
                vm.geolocation = response.data.rec;
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        retriveTemplate(template_id) {
            let vm = this

            if (this.reqCrit.template_id) {
            axios.get(this.$store.getters.rootAPI + '/export/template_detail/' + template_id)
                .then(function (response) {
                    vm.template = response.data.rec;
                    vm.dialogTemplate = !vm.dialogTemplate;
                })
                .catch(function (error) {
                    vm.status = 'An error occured.' + error;
                })
            } else {
                alert("Please select a template to view")
            }
        },

        setExportCriteria() {
            let projects = []
            for (let p = 0; p < this.projectSelection.length; p++) {
                projects.push(this.projectSelection[p].id)
            }

            let reasons = []
            for (let r = 0; r < this.reasonSelection.length; r++) {
                reasons.push(this.reasonSelection[r].id)
            }

            let companies = []
            for (let c = 0; c < this.companySelection.length; c++) {
                companies.push(this.companySelection[c].id)
            }

            let geolocation = []
            for (let g = 0; g < this.geolocationSelection.length; g++) {
                geolocation.push(this.geolocationSelection[g].id)
            }

            let selectedProjects = projects
            let selectedReasons = reasons
            let selectedCompanies = companies
            let selectedGeolocation = geolocation

            this.$store.commit('setExportCriteria', {
                start_date: this.reqCrit.start_date,
                end_date: this.reqCrit.end_date,
                template_id: this.reqCrit.template_id,
                //project_id: this.reqCrit.project_id,
                project_id: selectedProjects,
                reason_id: selectedReasons,
                company_id: selectedCompanies,
                geolocation_id: selectedGeolocation,
                //reason_id: this.reqCrit.reason_id,
                //company_id: this.reqCrit.company_id ,
                filename: this.reqCrit.filename
            })
        },

        validateDate(){
            let route = '/' + this.$i18n.locale + '/export/process'

            if (this.reqCrit.start_date > this.reqCrit.end_date || this.reqCrit.end_date < this.reqCrit.start_date) {
                alert(this.label.start_date + " should be earlier than " + this.label.end_date)
            } else {
                this.setExportCriteria()
                this.$router.push(route)
            }
        },

        goToExport() {
            this.validateDate()
        }

    },

    created() {
        this.retriveTemplates();
        this.retriveProjects();
        this.retriveReasons();
        this.retriveCompanies();
        this.retriveGeolocation();
    }
}
</script>

<style scoped>
    table {
            margin: 0px;
        }

    th {
        background-color: blue;
        color: white;
    }
</style>


// WEBPACK FOOTER //
// src/components/export/ExportVerify.vue